export const translations = {
  en: {
    // Header
    home: "HOME",
    menu: "MENU",
    about: "ABOUT",
    delivery: "DELIVERY",
    orderNow: "ORDER NOW",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    myAccount: "My Account",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    phone: "Phone",
    noAccount: "Don't have an account?",
    registerNow: "Register now",
    alreadyHaveAccount: "Already have an account?",
    loginNow: "Login now",
    loading: "Loading...",
    passwordsMustMatch: "Passwords must match",
    passwordTooShort: "Password must be at least 6 characters",
    accountInformation: "Account Information",
    edit: "Edit",
    cancel: "Cancel",
    save: "Save",
    saveChanges: "Save Changes",
    savedAddresses: "Saved Addresses",
    addAddress: "Add Address",
    address: "Address",
    city: "City",
    zipCode: "ZIP Code",
    default: "Default",
    setAsDefault: "Set as default",
    confirmDeleteAddress: "Are you sure you want to delete this address?",
    noSavedAddresses: "No saved addresses yet",
    fillAllFields: "Please fill all required fields",
    pleaseLogin: "Please login to view this page",
    clickToView: "Click to view",
    
    // Hero Section
    fresh: "FRESH",
    authentic: "AUTHENTIC",
    delivered: "DELIVERED",
    heroTitle: "Authentic Pan Asian Cuisine",
    heroDescription: "Traditional sushi and poke bowls. Delivery in 30-60 minutes.",
    deliveryTime: "Delivery Time",
    deliveryMins: "30 - 60 min",
    freeDelivery: "Free Delivery",
    ordersOver: "Orders over €35",
    viewMenu: "VIEW MENU",
    customerRating: "Customer Rating",
    ordersDaily: "Orders Daily",
    promotionBanner: "🎉 Promotion! 25% off on orders over €50 until 31.01.2026!",
    specialOffer: "Special Offer!",
    off: "OFF",
    onOrdersOver: "on orders over",
    validUntil: "Valid until",
    startOrdering: "Start Ordering",
    closeWindow: "Close",
    promoAppliesAutomatically: "Discount applies automatically at checkout for orders €50+",
    
    // Featured Section
    bestSellers: "BEST SELLERS",
    featuredTitle: "Featured Selections",
    featuredDescription: "Popular dishes",
    popular: "Popular",
    
    // Menu Section
    ourMenu: "OUR MENU",
    exploreTitle: "Explore Our Selection",
    menuDescription: "Sushi and poke bowls",
    searchMenu: "Search menu...",
    noItemsFound: "No items found matching your search.",
    add: "Add",
    ordersUnavailable: "Orders are currently unavailable",
    ordersUnavailableMessage: "We apologize, but online ordering is temporarily disabled.\n\nYou can place your order by phone:\n+371 28717331",
    
    // Categories
    classicrolls: "Classic Rolls",
    specialrolls: "Special Rolls",
    tempurarolls: "Tempura Rolls",
    makirolls: "Maki Rolls",
    veganmaki: "Vegetarian Maki",
    poke: "Poke",
    
    // About Section
    ourStory: "OUR STORY",
    aboutTitle: "About",
    aboutSubtitle: "Mikado Sushi",
    aboutText1: "Pan Asian cuisine in Liepāja.",
    aboutText2: "Sushi rolls and poke bowls. Delivery and pickup.",
    sustainableSeafood: "Seafood sourced daily",
    traditionalTechniques: "Asian cooking techniques",
    madeToOrder: "Made to order",
    premiumIngredients: "Quality ingredients",
    
    // Features
    masterChefs: "Chefs",
    masterChefsDesc: "Experienced team preparing Asian dishes.",
    freshIngredients: "Fresh Ingredients",
    freshIngredientsDesc: "Fish and ingredients sourced daily.",
    fastDelivery: "Fast Delivery",
    fastDeliveryDesc: "Delivery in 30-45 minutes.",
    qualityAssured: "Quality Check",
    qualityAssuredDesc: "Orders inspected before delivery.",
    
    // Delivery Section
    deliveryInfo: "DELIVERY INFO",
    deliveryTitle: "Fast & Fresh Delivery",
    deliveryDescription: "Delivery to your address",
    minimumOrder: "Minimum Order",
    deliveryFee: "Delivery Fee",
    freeOver: "Free over",
    contactUs: "Contact Us",
    available: "Available 12:00 - 22:00",
    deliveryZones: "Delivery Zones",
    deliveryZonesText: "We currently deliver to:",
    allLiepaja: "All Liepaja",
    specialInstructions: "Special Instructions",
    instruction1: "Orders placed before 9 PM for same-day delivery",
    instruction2: "Special dietary requests accommodated",
    instruction3: "Contactless delivery available upon request",
    instruction4: "Track your order in real-time",
    yearsExperience: "Years Experience",
    
    // Footer
    footerDescription: "Pan Asian cuisine delivery in Liepāja.",
    quickLinks: "Quick Links",
    contactInfo: "Contact Us",
    businessHours: "Business Hours",
    monday: "Monday",
    tueThu: "Tue - Thu",
    friSat: "Fri - Sat",
    sunday: "Sunday",
    closed: "Closed",
    allRightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
    
    // Cart
    yourCart: "Your Cart",
    cartEmpty: "Your cart is empty",
    cartEmptyDesc: "Add some delicious sushi to get started!",
    browseMenu: "Browse Menu",
    subtotal: "Subtotal",
    free: "FREE",
    addMore: "Add",
    forFreeDelivery: "more for free delivery",
    total: "Total",
    proceedToCheckout: "Proceed to Checkout",
    
    // Checkout
    checkout: "Checkout",
    fullName: "Full Name",
    fullNamePlaceholder: "John Doe",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "+371 28717331",
    email: "Email",
    emailPlaceholder: "john@example.com",
    optional: "(Optional)",
    deliveryAddress: "Delivery Address",
    city: "City",
    zipCode: "Zip Code",
    specialInstructionsLabel: "Special Instructions",
    specialInstructionsPlaceholder: "Any special requests or delivery instructions...",
    orderSummary: "Order Summary",
    cancel: "Cancel",
    placeOrder: "Place Order",
    missingInfo: "Missing Information",
    fillAllFields: "Please fill in all required fields.",
    orderSuccess: "Order Placed Successfully!",
    orderConfirmation: "Your order will arrive in",
    
    // Toast messages
    addedToCart: "Added to cart",
    itemAdded: "has been added to your cart.",
    itemRemoved: "Item removed",
    itemRemovedDesc: "Item has been removed from your cart.",
    
    // Checkout Modal - Additional
    orderType: "Order Type",
    deliveryOption: "Delivery",
    pickupOption: "Pickup",
    pickupAddress: "Pickup Address",
    pickupTimeLabel: "Pickup Time",
    paymentMethod: "Payment Method",
    creditCard: "Credit / Debit Card",
    cashOnDelivery: "Cash on Delivery",
    deliveryTimeLabel: "Delivery Time",
    asap: "ASAP",
    scheduleForLater: "Schedule for later",
    startTypingAddress: "Start typing street name in Liepaja...",
    deliveryNotAvailable: "Delivery Not Available",
    onlyDeliverLiepaja: "We only deliver within Liepāja city limits. Please select an address in Liepāja.",
    onlyDeliverLiepajaPickup: "We only deliver within Liepāja. Please select an address in Liepāja or choose Pickup.",
    addressValidationRequired: "Address Validation Required",
    selectAddressFromDropdown: "Please select your address from the dropdown suggestions.",
    distanceFrom: "Distance:",
    kmFrom: "km from Liepu iela 9",
    pickupDiscount: "Pickup Discount (10%)",
    minOrderDelivery: "€20 minimum only for delivery. No minimum for pickup.",
    minOrderWarning: "Minimum order for delivery is €20.00. Add another €{amount} or choose Pickup.",
    ordersEuro2035: "Orders €20-35",
    allergens: "Allergens",
    discount: "Discount",
    promotionApplied: "Promotion applied",
    
    // Order Success Page
    orderConfirmed: "Order Confirmed!",
    processingPayment: "Processing Your Payment...",
    pleaseWait: "Please wait while we confirm your order",
    thankYouOrder: "Thank you for your order! Your delicious sushi will arrive in 30-60 minutes.",
    orderDetails: "Order Details",
    amount: "Amount",
    status: "Status",
    confirmed: "Confirmed",
    paymentInfo: "Payment",
    backToHome: "Back to Home",
    paymentExpired: "Payment Expired",
    paymentError: "Payment Error",
    sessionExpired: "Your payment session has expired. Please try again.",
    errorProcessing: "There was an error processing your payment. Please try again.",
    saveOnPickup: "Save on pickup orders",
    averageDelivery: "Average delivery",
    pickupDiscountTitle: "Pickup Discount",
    weDeliverAcrossLiepaja: "We Deliver Across Liepāja",
    fastReliableDelivery: "Fast and reliable delivery to any location in Liepāja city",
    freeDeliveryAmount: "€35+",
    deliveryFeeAmount: "€2.50",
    
    // Content Pages
    backToHome: "Back to Home",
    privacyPolicyTitle: "Privacy Policy",
    termsTitle: "Terms & Conditions",
    companyDetailsTitle: "Company Details",
    
    // Privacy Policy
    ppIntroTitle: "Introduction",
    ppIntroText: "Mikado Sushi (operated by SIA \"Hermes invest\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our website and services.",
    ppInfoCollectTitle: "Information We Collect",
    ppInfoCollectText: "We collect the following information when you place an order:",
    ppInfoItem1: "Name and contact information (phone number, email address)",
    ppInfoItem2: "Delivery address (for delivery orders)",
    ppInfoItem3: "Order details and preferences",
    ppInfoItem4: "Payment information (processed securely through Stripe)",
    ppHowUseTitle: "How We Use Your Information",
    ppHowUseText: "Your information is used to:",
    ppUseItem1: "Process and deliver your orders",
    ppUseItem2: "Communicate with you about your order status",
    ppUseItem3: "Improve our services and customer experience",
    ppUseItem4: "Send promotional offers (only with your consent)",
    ppDataProtectionTitle: "Data Protection",
    ppDataProtectionText: "We implement appropriate security measures to protect your personal data. Your payment information is processed securely through Stripe and is never stored on our servers. We do not share your personal information with third parties except as necessary to fulfill your order.",
    ppCookiesTitle: "Cookies",
    ppCookiesText: "Our website uses cookies to enhance your browsing experience. We use cookies to remember your language preference and shopping cart contents. You can disable cookies in your browser settings, though this may affect website functionality.",
    ppYourRightsTitle: "Your Rights",
    ppYourRightsText: "You have the right to:",
    ppRightItem1: "Access your personal data",
    ppRightItem2: "Request correction of inaccurate data",
    ppRightItem3: "Request deletion of your data",
    ppRightItem4: "Withdraw consent for marketing communications",
    ppContactTitle: "Contact Us",
    ppContactText: "If you have any questions about this Privacy Policy, please contact us:",
    ppLastUpdated: "Last updated: November 2025",
    
    // Terms & Conditions
    tcDeliveryTitle: "Delivery",
    tcDeliveryItem1: "Free delivery on orders over €35 within Liepāja.",
    tcDeliveryItem2: "Average delivery time: 30 min - 1 hour.",
    tcDeliveryItem3: "Pickup discount: 10%.",
    tcDeliveryItem4: "Delivery is only made to the address specified in the order.",
    tcDeliveryItem5: "During high-demand periods (Friday, weekends), delivery time may be extended.",
    tcPaymentTitle: "Payment",
    tcPaymentItem1: "Payment in cash to the courier or online on the website.",
    tcPaymentItem2: "All prices are in euros, including VAT.",
    tcReturnTitle: "Return Policy",
    tcReturnItem1: "If the sushi or dish was damaged during delivery, contact us at",
    or: "or",
    within24Hours: "within 24 hours.",
    tcReturnItem2: "Refund or compensation is possible only upon presentation of a photo and description of the situation.",
    tcReturnItem3: "Complaints about the quality of custom-made dishes are considered individually.",
    tcAgeTitle: "Age Restrictions",
    tcAgeItem1: "Sale and delivery of alcoholic beverages is permitted only to persons over 18 years of age.",
    tcAgeItem2: "When receiving alcoholic products, it is necessary to present an identity document confirming age.",
    tcAgeItem3: "Alcohol delivery is prohibited from 22:00 to 8:00.",
    
    // Company Details
    cdCompanyInfoTitle: "Company Information",
    cdCompanyName: "Company Name",
    cdRegistrationNumber: "Registration Number",
    cdLegalAddress: "Legal Address",
    cdBankingInfo: "Banking Information",
    cdBankName: "Bank Name",
    cdSwiftCode: "SWIFT/BIC Code",
    cdAccountNumber: "Account Number (IBAN)",
    cdManagement: "Management",
    cdBoardMember: "Board Member",
    cdRestaurantContact: "Restaurant Contact",
    pickupAvailable: "Pickup Available",
    
    // Location Selector
    chooseLocation: "CHOOSE YOUR RESTAURANT",
    selectYourCity: "Select your restaurant to continue",
    italianPizza: "Italian Pizza",
    panAsianCuisine: "Pan Asian Cuisine",
    enter: "ENTER",
    
    // Allergens
    allergensTitle: "Allergens",
    allergenListTitle: "Allergen List",
    allergenIntro: "Our dishes may contain the following allergens. Numbers correspond to allergen codes:",
    allergen1: "Celery",
    allergen2: "Gluten-containing cereals (e.g., wheat, barley, oats)",
    allergen3: "Crustaceans (e.g., crab, lobster, shrimp)",
    allergen4: "Eggs",
    allergen5: "Fish",
    allergen6: "Lupin",
    allergen7: "Milk",
    allergen8: "Molluscs (e.g., clams, oysters)",
    allergen9: "Mustard",
    allergen10: "Peanuts",
    allergen11: "Sesame seeds",
    allergen12: "Soybeans",
    allergen13: "Sulfur dioxide and sulfites (concentration more than 10 mg/kg or 10 mg/l)",
    allergen14: "Tree nuts",
    allergenNote: "If you have specific allergy concerns, please contact us before ordering.",
  },
  
  lv: {
    // Header
    home: "SĀKUMS",
    menu: "ĒDIENKARTE",
    about: "PAR MUMS",
    delivery: "PIEGĀDE",
    orderNow: "PASŪTĪT",
    
    // Auth
    login: "Ieiet",
    register: "Reģistrēties",
    logout: "Iziet",
    myAccount: "Mans konts",
    email: "E-pasts",
    password: "Parole",
    confirmPassword: "Apstipriniet paroli",
    name: "Vārds",
    phone: "Tālrunis",
    noAccount: "Nav konta?",
    registerNow: "Reģistrējieties tagad",
    alreadyHaveAccount: "Jau ir konts?",
    loginNow: "Ieiet tagad",
    loading: "Ielādē...",
    passwordsMustMatch: "Parolēm jāsakrīt",
    passwordTooShort: "Parolei jābūt vismaz 6 rakstzīmēm",
    accountInformation: "Konta informācija",
    edit: "Rediģēt",
    cancel: "Atcelt",
    save: "Saglabāt",
    saveChanges: "Saglabāt izmaiņas",
    savedAddresses: "Saglabātās adreses",
    addAddress: "Pievienot adresi",
    address: "Adrese",
    city: "Pilsēta",
    zipCode: "Pasta indekss",
    default: "Noklusējums",
    setAsDefault: "Iestatīt kā noklusējumu",
    confirmDeleteAddress: "Vai tiešām vēlaties dzēst šo adresi?",
    noSavedAddresses: "Nav saglabātu adrešu",
    fillAllFields: "Lūdzu, aizpildiet visus laukus",
    pleaseLogin: "Lūdzu, ieejiet, lai skatītu šo lapu",
    clickToView: "Noklikšķiniet, lai skatītu",
    
    // Hero Section
    fresh: "SVAIGS",
    authentic: "AUTENTISKS",
    delivered: "PIEGĀDĀTS",
    heroTitle: "Autentiska Panāzijas Virtuve",
    heroDescription: "Tradicionāli suši un poke. Piegāde 30-60 minūtēs.",
    deliveryTime: "Piegādes Laiks",
    deliveryMins: "30 - 60 min",
    freeDelivery: "Bezmaksas Piegāde",
    ordersOver: "Pasūtījumiem virs €35",
    viewMenu: "SKATĪT ĒDIENKARTI",
    customerRating: "Klientu Vērtējums",
    ordersDaily: "Pasūtījumi Dienā",
    promotionBanner: "🎉 Akcija! Atlaide 25% pasūtījumiem no €50 līdz 31.01.2026!",
    specialOffer: "Īpašais piedāvājums!",
    off: "ATLAIDE",
    onOrdersOver: "pasūtījumiem no",
    validUntil: "Derīgs līdz",
    startOrdering: "Sākt Pasūtīt",
    closeWindow: "Aizvērt",
    promoAppliesAutomatically: "Atlaide tiek piemērota automātiski apmaksas laikā pasūtījumiem no €50",
    
    // Featured Section
    bestSellers: "POPULĀRĀKIE",
    featuredTitle: "Ieteiktie Ēdieni",
    featuredDescription: "Populāri ēdieni",
    popular: "Populārs",
    
    // Menu Section
    ourMenu: "MŪSU ĒDIENKARTE",
    exploreTitle: "Iepazīstiet Mūsu Izvēli",
    menuDescription: "Suši un poke",
    searchMenu: "Meklēt ēdienkarti...",
    noItemsFound: "Nav atrasti ēdieni, kas atbilst meklēšanai.",
    add: "Pievienot",
    ordersUnavailable: "Pasūtījumi pašlaik nav pieejami",
    ordersUnavailableMessage: "Atvainojamies, bet tiešsaistes pasūtījumi ir īslaicīgi atspējoti.\n\nJūs varat veikt pasūtījumu pa tālruni:\n+371 28717331",
    
    // Categories
    classicrolls: "Klasiskie",
    specialrolls: "Speciālie",
    tempurarolls: "Tempura",
    makirolls: "Maki",
    veganmaki: "Veģetāriskie Maki",
    poke: "Poke",
    
    // About Section
    ourStory: "PAR MUMS",
    aboutTitle: "Par",
    aboutSubtitle: "Mikado Sushi",
    aboutText1: "Panāzijas virtuve Liepājā.",
    aboutText2: "Suši un poke. Piegāde un saņemšana uz vietas.",
    sustainableSeafood: "Jūras veltes",
    traditionalTechniques: "Tradicionālās Āzijas gatavošanas tehnikas",
    madeToOrder: "Gatavots pēc pasūtījuma",
    premiumIngredients: "Augstākās kvalitātes sastāvdaļas",
    
    // Features
    masterChefs: "Pavāri",
    masterChefsDesc: "Pieredzējusi komanda gatavo Āzijas ēdienus.",
    freshIngredients: "Svaigas Sastāvdaļas",
    freshIngredientsDesc: "Svaigu sastāvdaļu piegāde katru dienu.",
    fastDelivery: "Ātra Piegāde",
    fastDeliveryDesc: "Piegāde 30-45 minūtēs.",
    qualityAssured: "Kvalitātes Pārbaude",
    qualityAssuredDesc: "Pasūtījumi pārbaudīti pirms piegādes.",
    
    // Delivery Section
    deliveryInfo: "PIEGĀDES INFO",
    deliveryTitle: "Ātra un Svaiga Piegāde",
    deliveryDescription: "Piegāde uz jūsu adresi",
    minimumOrder: "Minimālais Pasūtījums",
    deliveryFee: "Piegādes Maksa",
    freeOver: "Bezmaksas virs",
    contactUs: "Sazinies ar Mums",
    available: "Pieejams 12:00 - 22:00",
    deliveryZones: "Piegādes Zonas",
    deliveryZonesText: "Mēs pašlaik piegādājam:",
    allLiepaja: "Visa Liepāja",
    specialInstructions: "Īpašie Norādījumi",
    instruction1: "Pasūtījumi veikti pirms 21:00 tiek piegādāti tajā pašā dienā",
    instruction2: "Īpašas uztura prasības tiek ņemtas vērā",
    instruction3: "Bezkontakta piegāde pieejama pēc pieprasījuma",
    instruction4: "Sekojiet savam pasūtījumam reāllaikā",
    yearsExperience: "Gadu Pieredze",
    
    // Footer
    footerDescription: "Panaziātu virtuves piegāde Liepājā.",
    quickLinks: "Ātras Saites",
    contactInfo: "Sazinies ar Mums",
    businessHours: "Darba Laiks",
    monday: "Pirmdiena",
    tueThu: "O - C",
    friSat: "Pk - S",
    sunday: "Svētdiena",
    closed: "Slēgts",
    allRightsReserved: "Visas tiesības aizsargātas.",
    privacyPolicy: "Privātuma Politika",
    termsOfService: "Lietošanas Noteikumi",
    cookiePolicy: "Sīkdatņu Politika",
    
    // Cart
    yourCart: "Jūsu Grozs",
    cartEmpty: "Jūsu grozs ir tukšs",
    cartEmptyDesc: "Pievienojiet garšīgu suši, lai sāktu!",
    browseMenu: "Skatīt Ēdienkarti",
    subtotal: "Starpsumma",
    free: "BEZMAKSAS",
    addMore: "Pievienot vēl",
    forFreeDelivery: "bezmaksas piegādei",
    total: "Kopā",
    proceedToCheckout: "Turpināt uz Apmaksu",
    
    // Checkout
    checkout: "Apmaksa",
    fullName: "Pilns Vārds",
    fullNamePlaceholder: "Jānis Bērziņš",
    phoneNumber: "Tālruņa Numurs",
    phoneNumberPlaceholder: "+371 28717331",
    email: "E-pasts",
    emailPlaceholder: "jūsu@epasts.lv",
    optional: "(Neobligāts)",
    deliveryAddress: "Piegādes Adrese",
    city: "Pilsēta",
    zipCode: "Pasta Indekss",
    specialInstructionsLabel: "Īpašie Norādījumi",
    specialInstructionsPlaceholder: "Jebkādi īpaši pieprasījumi vai piegādes norādījumi...",
    orderSummary: "Pasūtījuma Kopsavilkums",
    cancel: "Atcelt",
    placeOrder: "Veikt Pasūtījumu",
    missingInfo: "Trūkst Informācijas",
    fillAllFields: "Lūdzu, aizpildiet visus obligātos laukus.",
    orderSuccess: "Pasūtījums Veiksmīgi Veikts!",
    orderConfirmation: "Jūsu pasūtījums pienāks",
    
    // Toast messages
    addedToCart: "Pievienots grozam",
    itemAdded: "ir pievienots jūsu grozam.",
    itemRemoved: "Prece noņemta",
    itemRemovedDesc: "Prece ir noņemta no jūsu groza.",
    
    // Checkout Modal - Additional
    orderType: "Pasūtījuma Veids",
    deliveryOption: "Piegāde",
    pickupOption: "Līdzņemšana",
    pickupAddress: "Izņemšanas Adrese",
    pickupTimeLabel: "Izņemšanas Laiks",
    paymentMethod: "Maksājuma Veids",
    creditCard: "Kredītkarte / Debetkarte",
    cashOnDelivery: "Skaidra Nauda Piegādē",
    deliveryTimeLabel: "Piegādes Laiks",
    asap: "Cik drīz vien iespējams",
    scheduleForLater: "Ieplānot vēlāk",
    startTypingAddress: "Sāciet rakstīt ielas nosaukumu Liepājā...",
    deliveryNotAvailable: "Piegāde Nav Pieejama",
    onlyDeliverLiepaja: "Mēs piegādājam tikai Liepājas pilsētas robežās. Lūdzu, izvēlieties adresi Liepājā.",
    onlyDeliverLiepajaPickup: "Mēs piegādājam tikai Liepājā. Lūdzu, izvēlieties adresi Liepājā vai izvēlieties Izņemšanu.",
    addressValidationRequired: "Nepieciešama Adreses Validācija",
    selectAddressFromDropdown: "Lūdzu, izvēlieties savu adresi no nolaižamā saraksta ieteikumiem.",
    distanceFrom: "Attālums:",
    kmFrom: "km no Liepu iela 9",
    pickupDiscount: "Līdzņemšanas atlaide (10%)",
    minOrderDelivery: "€20 minimums tikai piegādei. Līdzņemšanai nav minimuma.",
    minOrderWarning: "Minimālais pasūtījums piegādei ir €20.00. Pievienojiet vēl €{amount} vai izvēlieties Paņemšanu.",
    ordersEuro2035: "Pasūtījumi €20-35",
    allergens: "Alergēni",
    discount: "Atlaide",
    promotionApplied: "Akcija piemērota",
    
    // Order Success Page
    orderConfirmed: "Pasūtījums apstiprināts!",
    processingPayment: "Apstrādājam Jūsu maksājumu...",
    pleaseWait: "Lūdzu, uzgaidiet, kamēr apstiprinām jūsu pasūtījumu",
    thankYouOrder: "Paldies par jūsu pasūtījumu! Jūsu garšīgie suši ieradīsies 30-60 minūšu laikā.",
    orderDetails: "Pasūtījuma detaļas",
    amount: "Summa",
    status: "Statuss",
    confirmed: "Apstiprināts",
    paymentInfo: "Maksājums",
    backToHome: "Atpakaļ uz sākumu",
    paymentExpired: "Maksājums beidzies",
    paymentError: "Maksājuma kļūda",
    sessionExpired: "Jūsu maksājuma sesija ir beigusies. Lūdzu, mēģiniet vēlreiz.",
    errorProcessing: "Apstrādājot jūsu maksājumu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    saveOnPickup: "Līdzņemšanas atlaide -10%",
    averageDelivery: "Vidējais piegādes laiks",
    pickupDiscountTitle: "Līdzņemšanas atlaide",
    weDeliverAcrossLiepaja: "Mēs Piegādājam Visā Liepājā",
    fastReliableDelivery: "Ātra un uzticama piegāde jebkurā Liepājas pilsētas vietā",
    freeDeliveryAmount: "virs 35 €",
    deliveryFeeAmount: "2,50 €",
    
    // Content Pages
    backToHome: "Atpakaļ uz Sākumu",
    privacyPolicyTitle: "Privātuma Politika",
    termsTitle: "Lietošanas Noteikumi",
    companyDetailsTitle: "Uzņēmuma Informācija",
    
    // Privacy Policy
    ppIntroTitle: "Ievads",
    ppIntroText: "Mikado Sushi (ko vada SIA \"Hermes invest\") ir apņēmusies aizsargāt jūsu privātumu. Šī Privātuma politika izskaidro, kā mēs vācam, izmantojam un aizsargājam jūsu personas informāciju, kad jūs izmantojat mūsu vietni un pakalpojumus.",
    ppInfoCollectTitle: "Informācija, ko Mēs Vācam",
    ppInfoCollectText: "Mēs vācam šādu informāciju, kad jūs veicat pasūtījumu:",
    ppInfoItem1: "Vārds un kontaktinformācija (tālruņa numurs, e-pasta adrese)",
    ppInfoItem2: "Piegādes adrese (piegādes pasūtījumiem)",
    ppInfoItem3: "Pasūtījuma detaļas un preferences",
    ppInfoItem4: "Maksājuma informācija (apstrādāta droši caur Stripe)",
    ppHowUseTitle: "Kā Mēs Izmantojam Jūsu Informāciju",
    ppHowUseText: "Jūsu informācija tiek izmantota, lai:",
    ppUseItem1: "Apstrādātu un piegādātu jūsu pasūtījumus",
    ppUseItem2: "Sazinātos ar jums par jūsu pasūtījuma statusu",
    ppUseItem3: "Uzlabotu mūsu pakalpojumus un klientu pieredzi",
    ppUseItem4: "Nosūtītu reklāmas piedāvājumus (tikai ar jūsu piekrišanu)",
    ppDataProtectionTitle: "Datu Aizsardzība",
    ppDataProtectionText: "Mēs ieviešam atbilstošus drošības pasākumus, lai aizsargātu jūsu personas datus. Jūsu maksājuma informācija tiek apstrādāta droši caur Stripe un nekad netiek glabāta mūsu serveros. Mēs nedalāmies ar jūsu personas informāciju ar trešajām pusēm, izņemot gadījumus, kad tas ir nepieciešams jūsu pasūtījuma izpildei.",
    ppCookiesTitle: "Sīkdatnes",
    ppCookiesText: "Mūsu vietne izmanto sīkdatnes, lai uzlabotu jūsu pārlūkošanas pieredzi. Mēs izmantojam sīkdatnes, lai atcerētos jūsu valodas izvēli un iepirkumu groza saturu. Jūs varat atspējot sīkdatnes savā pārlūkprogrammas iestatījumos, lai gan tas var ietekmēt vietnes funkcionalitāti.",
    ppYourRightsTitle: "Jūsu Tiesības",
    ppYourRightsText: "Jums ir tiesības:",
    ppRightItem1: "Piekļūt saviem personas datiem",
    ppRightItem2: "Pieprasīt neprecīzu datu labošanu",
    ppRightItem3: "Pieprasīt savu datu dzēšanu",
    ppRightItem4: "Atsaukt piekrišanu mārketinga komunikācijai",
    ppContactTitle: "Sazinieties ar Mums",
    ppContactText: "Ja jums ir jautājumi par šo Privātuma politiku, lūdzu, sazinieties ar mums:",
    ppLastUpdated: "Pēdējoreiz atjaunināts: 2025. gada novembris",
    
    // Terms & Conditions
    tcDeliveryTitle: "Piegāde",
    tcDeliveryItem1: "Bezmaksas piegāde pasūtījumiem virs 35 €.",
    tcDeliveryItem2: "Vidējais piegādes laiks: 30 min – 1 st.",
    tcDeliveryItem3: "Līdzņemšanas atlaide: 10%.",
    tcDeliveryItem4: "Piegāde tiek veikta tikai uz pasūtījumā norādīto adresi.",
    tcDeliveryItem5: "Lielā pieprasījuma periodos (piektdiena, nedēļas nogales) piegādes laiks var tikt pagarināts.",
    tcPaymentTitle: "Maksājums",
    tcPaymentItem1: "Maksājums skaidrā naudā kurjeram vai tiešsaistē vietnē.",
    tcPaymentItem2: "Visas cenas ir euro, ieskaitot PVN.",
    tcReturnTitle: "Atgriešanas Politika",
    tcReturnItem1: "Ja suši vai ēdiens tika bojāts piegādes laikā, sazinieties ar mums",
    or: "vai",
    within24Hours: "24 stundu laikā.",
    tcReturnItem2: "Atmaksa vai kompensācija ir iespējama tikai, iesniedzot fotogrāfiju un situācijas aprakstu.",
    tcReturnItem3: "Sūdzības par pasūtījuma ēdienu kvalitāti tiek izskatītas individuāli.",
    tcAgeTitle: "Vecuma Ierobežojumi",
    tcAgeItem1: "Alkoholisko dzērienu pārdošana un piegāde ir atļauta tikai personām, kas vecākas par 18 gadiem.",
    tcAgeItem2: "Saņemot alkoholiskos produktus, ir jāuzrāda identitātes dokuments, kas apstiprina vecumu.",
    tcAgeItem3: "Alkohola piegāde ir aizliegta no 22:00 līdz 8:00.",
    
    // Company Details
    cdCompanyInfoTitle: "Uzņēmuma Informācija",
    cdCompanyName: "Uzņēmuma Nosaukums",
    cdRegistrationNumber: "Reģistrācijas Numurs",
    cdLegalAddress: "Juridiskā Adrese",
    cdBankingInfo: "Bankas Informācija",
    cdBankName: "Bankas Nosaukums",
    cdSwiftCode: "SWIFT/BIC Kods",
    cdAccountNumber: "Konta Numurs (IBAN)",
    cdManagement: "Vadība",
    cdBoardMember: "Valdes Loceklis",
    cdRestaurantContact: "Restorāna Kontakti",
    pickupAvailable: "Saņemšana uz vietas",
    
    // Location Selector
    chooseLocation: "IZVĒLIES RESTORĀNU",
    selectYourCity: "Izvēlies savu restorānu, lai turpinātu",
    italianPizza: "Itāļu Pica",
    panAsianCuisine: "Panaziātu Virtuve",
    enter: "IENĀKT",
    
    // Allergens
    allergensTitle: "Alergēni",
    allergenListTitle: "Alergēnu Saraksts",
    allergenIntro: "Mūsu ēdienos var būt šādi alergēni. Numuri atbilst alergēnu kodiem:",
    allergen1: "Selerija",
    allergen2: "Glutēnu saturoši labības produkti (piemēram, kvieši, mieži, auzas)",
    allergen3: "Vēžveidīgie (piemēram, krabis, omārs, garneles)",
    allergen4: "Olas",
    allergen5: "Zivis",
    allergen6: "Lupīna",
    allergen7: "Piens",
    allergen8: "Mīkstmieši (piemēram, gliemenes, austeres)",
    allergen9: "Sinepes",
    allergen10: "Zemesrieksti",
    allergen11: "Sezama sēklas",
    allergen12: "Sojas pupas",
    allergen13: "Sēra dioksīds un sulfīti (koncentrācijā vairāk nekā 10 mg/kg vai 10 mg/l)",
    allergen14: "Rieksti (koku rieksti)",
    allergenNote: "Ja jums ir īpašas alergēnu problēmas, lūdzu, sazinieties ar mums pirms pasūtījuma veikšanas.",
  },
  
  ru: {
    // Header
    home: "ГЛАВНАЯ",
    menu: "МЕНЮ",
    about: "О НАС",
    delivery: "ДОСТАВКА",
    orderNow: "ЗАКАЗАТЬ",
    
    // Auth
    login: "Войти",
    register: "Регистрация",
    logout: "Выйти",
    myAccount: "Мой аккаунт",
    email: "Email",
    password: "Пароль",
    confirmPassword: "Подтвердите пароль",
    name: "Имя",
    phone: "Телефон",
    noAccount: "Нет аккаунта?",
    registerNow: "Зарегистрироваться",
    alreadyHaveAccount: "Уже есть аккаунт?",
    loginNow: "Войти",
    loading: "Загрузка...",
    passwordsMustMatch: "Пароли должны совпадать",
    passwordTooShort: "Пароль должен быть не менее 6 символов",
    accountInformation: "Информация об аккаунте",
    edit: "Редактировать",
    cancel: "Отмена",
    save: "Сохранить",
    saveChanges: "Сохранить изменения",
    savedAddresses: "Сохранённые адреса",
    addAddress: "Добавить адрес",
    address: "Адрес",
    city: "Город",
    zipCode: "Индекс",
    default: "По умолчанию",
    setAsDefault: "Установить по умолчанию",
    confirmDeleteAddress: "Вы уверены, что хотите удалить этот адрес?",
    noSavedAddresses: "Нет сохранённых адресов",
    fillAllFields: "Пожалуйста, заполните все поля",
    pleaseLogin: "Пожалуйста, войдите для просмотра этой страницы",
    clickToView: "Нажмите для просмотра",
    
    // Hero Section
    fresh: "СВЕЖЕЕ",
    authentic: "АУТЕНТИЧНОЕ",
    delivered: "ДОСТАВЛЕНО",
    heroTitle: "Аутентичная Паназиатская Кухня",
    heroDescription: "Традиционные суши роллы и поке боулы. Доставка за 30-45 минут.",
    deliveryTime: "Время Доставки",
    deliveryMins: "30 - 60 мин",
    freeDelivery: "Бесплатная Доставка",
    ordersOver: "Заказы от €35",
    viewMenu: "СМОТРЕТЬ МЕНЮ",
    customerRating: "Рейтинг Клиентов",
    ordersDaily: "Заказов в День",
    promotionBanner: "🎉 Акция! Скидка 25% на заказы от 50€ до 31.01.2026!",
    specialOffer: "Специальное предложение!",
    off: "СКИДКА",
    onOrdersOver: "на заказы от",
    validUntil: "Действует до",
    startOrdering: "Начать Заказ",
    closeWindow: "Закрыть",
    promoAppliesAutomatically: "Скидка применяется автоматически при оформлении заказов от €50",
    
    // Featured Section
    bestSellers: "ХИТЫ ПРОДАЖ",
    featuredTitle: "Рекомендуемые Блюда",
    featuredDescription: "Популярные блюда",
    popular: "Популярное",
    
    // Menu Section
    ourMenu: "НАШЕ МЕНЮ",
    exploreTitle: "Изучите Наш Выбор",
    menuDescription: "Суши роллы и поке боулы",
    searchMenu: "Поиск меню...",
    noItemsFound: "Не найдено блюд, соответствующих поиску.",
    add: "Добавить",
    ordersUnavailable: "Заказы в данный момент недоступны",
    ordersUnavailableMessage: "Приносим извинения, но онлайн-заказ временно отключен.\n\nВы можете сделать заказ по телефону:\n+371 28717331",
    
    // Categories
    classicrolls: "Классические",
    specialrolls: "Специальные",
    tempurarolls: "Темпура",
    makirolls: "Маки",
    veganmaki: "Вегетарианские Маки",
    poke: "Поке",
    
    // About Section
    ourStory: "О НАС",
    aboutTitle: "О",
    aboutSubtitle: "Mikado Sushi",
    aboutText1: "Паназиатская кухня в Лиепае.",
    aboutText2: "Суши и поке. Доставка и самовывоз.",
    sustainableSeafood: "Морепродукты",
    traditionalTechniques: "Азиатские техники приготовления",
    madeToOrder: "Приготовлено на заказ",
    premiumIngredients: "Качественные ингредиенты",
    
    // Features
    masterChefs: "Повара",
    masterChefsDesc: "Опытная команда готовит азиатские блюда.",
    freshIngredients: "Свежие Ингредиенты",
    freshIngredientsDesc: "Рыба и ингредиенты закупаются ежедневно.",
    fastDelivery: "Быстрая Доставка",
    fastDeliveryDesc: "Доставка за 30-45 минут.",
    qualityAssured: "Проверка Качества",
    qualityAssuredDesc: "Заказы проверяются перед доставкой.",
    
    // Delivery Section
    deliveryInfo: "ИНФОРМАЦИЯ О ДОСТАВКЕ",
    deliveryTitle: "Быстрая и Свежая Доставка",
    deliveryDescription: "Доставка на ваш адрес",
    minimumOrder: "Минимальный Заказ",
    deliveryFee: "Стоимость Доставки",
    freeOver: "Бесплатно от",
    contactUs: "Свяжитесь с Нами",
    available: "Доступно 12:00 - 22:00",
    deliveryZones: "Зоны Доставки",
    deliveryZonesText: "Мы доставляем в:",
    allLiepaja: "Вся Лиепая",
    specialInstructions: "Специальные Инструкции",
    instruction1: "Заказы, размещенные до 21:00, доставляются в тот же день",
    instruction2: "Учитываются специальные диетические требования",
    instruction3: "Бесконтактная доставка доступна по запросу",
    instruction4: "Отслеживайте свой заказ в реальном времени",
    yearsExperience: "Лет Опыта",
    
    // Footer
    footerDescription: "Доставка паназиатской кухни в Лиепае.",
    quickLinks: "Быстрые Ссылки",
    contactInfo: "Свяжитесь с Нами",
    businessHours: "Часы Работы",
    monday: "Понедельник",
    tueThu: "Вт - Чт",
    friSat: "Пт - Сб",
    sunday: "Воскресенье",
    closed: "Закрыто",
    allRightsReserved: "Все права защищены.",
    privacyPolicy: "Политика Конфиденциальности",
    termsOfService: "Условия Использования",
    cookiePolicy: "Политика Куки",
    
    // Cart
    yourCart: "Ваша Корзина",
    cartEmpty: "Ваша корзина пуста",
    cartEmptyDesc: "Добавьте вкусные суши, чтобы начать!",
    browseMenu: "Смотреть Меню",
    subtotal: "Промежуточный Итог",
    free: "БЕСПЛАТНО",
    addMore: "Добавьте еще",
    forFreeDelivery: "для бесплатной доставки",
    total: "Итого",
    proceedToCheckout: "Перейти к Оформлению",
    
    // Checkout
    checkout: "Оформление",
    fullName: "Полное Имя",
    fullNamePlaceholder: "Иван Иванов",
    phoneNumber: "Номер Телефона",
    phoneNumberPlaceholder: "+371 28717331",
    email: "Email",
    emailPlaceholder: "ivan@example.com",
    optional: "(Необязательно)",
    deliveryAddress: "Адрес Доставки",
    city: "Город",
    zipCode: "Почтовый Индекс",
    specialInstructionsLabel: "Специальные Инструкции",
    specialInstructionsPlaceholder: "Любые специальные пожелания или инструкции по доставке...",
    orderSummary: "Итоги Заказа",
    cancel: "Отмена",
    placeOrder: "Разместить Заказ",
    missingInfo: "Недостающая Информация",
    fillAllFields: "Пожалуйста, заполните все обязательные поля.",
    orderSuccess: "Заказ Успешно Размещен!",
    orderConfirmation: "Ваш заказ прибудет через",
    
    // Toast messages
    addedToCart: "Добавлено в корзину",
    itemAdded: "добавлено в вашу корзину.",
    itemRemoved: "Товар удален",
    itemRemovedDesc: "Товар удален из вашей корзины.",
    
    // Checkout Modal - Additional
    orderType: "Тип Заказа",
    deliveryOption: "Доставка",
    pickupOption: "Самовывоз",
    pickupAddress: "Адрес Самовывоза",
    pickupTimeLabel: "Время Самовывоза",
    paymentMethod: "Способ Оплаты",
    creditCard: "Кредитная / Дебетовая Карта",
    cashOnDelivery: "Наличные При Доставке",
    deliveryTimeLabel: "Время Доставки",
    asap: "Как можно скорее",
    scheduleForLater: "Запланировать на потом",
    startTypingAddress: "Начните вводить название улицы в Лиепае...",
    deliveryNotAvailable: "Доставка Недоступна",
    onlyDeliverLiepaja: "Мы доставляем только в пределах города Лиепая. Пожалуйста, выберите адрес в Лиепае.",
    onlyDeliverLiepajaPickup: "Мы доставляем только в Лиепаю. Пожалуйста, выберите адрес в Лиепае или выберите Самовывоз.",
    addressValidationRequired: "Требуется Проверка Адреса",
    selectAddressFromDropdown: "Пожалуйста, выберите свой адрес из выпадающего списка предложений.",
    distanceFrom: "Расстояние:",
    kmFrom: "км от Liepu iela 9",
    pickupDiscount: "Скидка На Самовывоз (10%)",
    minOrderDelivery: "Минимум €20 только для доставки. Нет минимума для самовывоза.",
    minOrderWarning: "Минимальный заказ для доставки €20.00. Добавьте еще €{amount} или выберите Самовывоз.",
    ordersEuro2035: "Заказы €20-35",
    allergens: "Аллергены",
    discount: "Скидка",
    promotionApplied: "Акция применена",
    
    // Order Success Page
    orderConfirmed: "Заказ подтверждён!",
    processingPayment: "Обрабатываем Ваш платёж...",
    pleaseWait: "Пожалуйста, подождите, пока мы подтверждаем ваш заказ",
    thankYouOrder: "Спасибо за ваш заказ! Ваши вкусные суши прибудут через 30-60 минут.",
    orderDetails: "Детали заказа",
    amount: "Сумма",
    status: "Статус",
    confirmed: "Подтверждён",
    paymentInfo: "Оплата",
    backToHome: "Вернуться на главную",
    paymentExpired: "Платёж истёк",
    paymentError: "Ошибка платежа",
    sessionExpired: "Ваша сессия оплаты истекла. Пожалуйста, попробуйте снова.",
    errorProcessing: "Произошла ошибка при обработке вашего платежа. Пожалуйста, попробуйте снова.",
    saveOnPickup: "Экономьте на заказах самовывозом",
    averageDelivery: "Средняя доставка",
    pickupDiscountTitle: "Скидка На Самовывоз",
    weDeliverAcrossLiepaja: "Мы Доставляем По Всей Лиепае",
    fastReliableDelivery: "Быстрая и надежная доставка в любое место в городе Лиепая",
    freeDeliveryAmount: "€35+",
    deliveryFeeAmount: "€2.50",
    
    // Content Pages
    backToHome: "Назад на Главную",
    privacyPolicyTitle: "Политика Конфиденциальности",
    termsTitle: "Условия Использования",
    companyDetailsTitle: "Информация о Компании",
    
    // Privacy Policy
    ppIntroTitle: "Введение",
    ppIntroText: "Mikado Sushi (управляется SIA \"Hermes invest\") стремится защищать вашу конфиденциальность. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу личную информацию при использовании нашего сайта и услуг.",
    ppInfoCollectTitle: "Информация, Которую Мы Собираем",
    ppInfoCollectText: "Мы собираем следующую информацию при оформлении заказа:",
    ppInfoItem1: "Имя и контактная информация (номер телефона, адрес электронной почты)",
    ppInfoItem2: "Адрес доставки (для заказов с доставкой)",
    ppInfoItem3: "Детали и предпочтения заказа",
    ppInfoItem4: "Платежная информация (обрабатывается безопасно через Stripe)",
    ppHowUseTitle: "Как Мы Используем Вашу Информацию",
    ppHowUseText: "Ваша информация используется для:",
    ppUseItem1: "Обработки и доставки ваших заказов",
    ppUseItem2: "Связи с вами о статусе вашего заказа",
    ppUseItem3: "Улучшения наших услуг и клиентского опыта",
    ppUseItem4: "Отправки рекламных предложений (только с вашего согласия)",
    ppDataProtectionTitle: "Защита Данных",
    ppDataProtectionText: "Мы применяем соответствующие меры безопасности для защиты ваших личных данных. Ваша платежная информация обрабатывается безопасно через Stripe и никогда не хранится на наших серверах. Мы не передаем вашу личную информацию третьим лицам, кроме случаев, необходимых для выполнения вашего заказа.",
    ppCookiesTitle: "Cookies",
    ppCookiesText: "Наш сайт использует cookies для улучшения вашего опыта просмотра. Мы используем cookies для запоминания вашего языкового предпочтения и содержимого корзины покупок. Вы можете отключить cookies в настройках браузера, хотя это может повлиять на функциональность сайта.",
    ppYourRightsTitle: "Ваши Права",
    ppYourRightsText: "Вы имеете право:",
    ppRightItem1: "Получить доступ к своим личным данным",
    ppRightItem2: "Запросить исправление неточных данных",
    ppRightItem3: "Запросить удаление своих данных",
    ppRightItem4: "Отозвать согласие на маркетинговые сообщения",
    ppContactTitle: "Свяжитесь с Нами",
    ppContactText: "Если у вас есть вопросы об этой Политике конфиденциальности, пожалуйста, свяжитесь с нами:",
    ppLastUpdated: "Последнее обновление: ноябрь 2025",
    
    // Terms & Conditions
    tcDeliveryTitle: "Доставка",
    tcDeliveryItem1: "Бесплатная доставка заказов от €35 в пределах Лиепаи.",
    tcDeliveryItem2: "Среднее время доставки: 30 мин - 1 час.",
    tcDeliveryItem3: "Скидка на самовывоз: 10%.",
    tcDeliveryItem4: "Доставка осуществляется только по адресу, указанному в заказе.",
    tcDeliveryItem5: "В периоды высокого спроса (пятница, выходные) время доставки может быть увеличено.",
    tcPaymentTitle: "Оплата",
    tcPaymentItem1: "Оплата наличными курьеру или онлайн на сайте.",
    tcPaymentItem2: "Все цены указаны в евро с учетом НДС.",
    tcReturnTitle: "Политика Возврата",
    tcReturnItem1: "Если суши или блюдо было повреждено во время доставки, свяжитесь с нами",
    or: "или",
    within24Hours: "в течение 24 часов.",
    tcReturnItem2: "Возврат или компенсация возможны только при предъявлении фотографии и описания ситуации.",
    tcReturnItem3: "Жалобы на качество изготовленных на заказ блюд рассматриваются индивидуально.",
    tcAgeTitle: "Возрастные Ограничения",
    tcAgeItem1: "Продажа и доставка алкогольных напитков разрешена только лицам старше 18 лет.",
    tcAgeItem2: "При получении алкогольной продукции необходимо предъявить документ, удостоверяющий личность и подтверждающий возраст.",
    tcAgeItem3: "Доставка алкоголя запрещена с 22:00 до 8:00.",
    
    // Company Details
    cdCompanyInfoTitle: "Информация о Компании",
    cdCompanyName: "Название Компании",
    cdRegistrationNumber: "Регистрационный Номер",
    cdLegalAddress: "Юридический Адрес",
    cdBankingInfo: "Банковская Информация",
    cdBankName: "Название Банка",
    cdSwiftCode: "SWIFT/BIC Код",
    cdAccountNumber: "Номер Счета (IBAN)",
    cdManagement: "Управление",
    cdBoardMember: "Член Правления",
    cdRestaurantContact: "Контакты Ресторана",
    pickupAvailable: "Самовывоз Доступен",
    
    // Location Selector
    chooseLocation: "ВЫБЕРИТЕ РЕСТОРАН",
    selectYourCity: "Выберите свой ресторан, чтобы продолжить",
    italianPizza: "Итальянская Пицца",
    panAsianCuisine: "Паназиатская Кухня",
    enter: "ВОЙТИ",
    
    // Allergens
    allergensTitle: "Аллергены",
    allergenListTitle: "Список Аллергенов",
    allergenIntro: "Наши блюда могут содержать следующие аллергены. Номера соответствуют кодам аллергенов:",
    allergen1: "Сельдерей",
    allergen2: "Глютенсодержащие злаки (например, пшеница, ячмень, овес)",
    allergen3: "Ракообразные (например, краб, омар, креветки)",
    allergen4: "Яйца",
    allergen5: "Рыба",
    allergen6: "Люпин",
    allergen7: "Молоко",
    allergen8: "Моллюски (например, моллюски, устрицы)",
    allergen9: "Горчица",
    allergen10: "Арахис",
    allergen11: "Семена кунжута",
    allergen12: "Соя",
    allergen13: "Диоксид серы и сульфиты (концентрация более 10 мг/кг или 10 мг/л)",
    allergen14: "Орехи (древесные орехи)",
    allergenNote: "Если у вас есть особые проблемы с аллергией, пожалуйста, свяжитесь с нами перед заказом.",
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
};
